import React from 'react';
import { CheckIcon, CrossIcon, TextError } from 'src/components';
import { SText } from 'src/components/SText';
import { $colors } from 'src/theme';

type Props = {
  testID?: string;
  title: string;
  description?: string;
  error?: Error | null;
};

export const IndicatorStep: React.FC<Props> = ({ error, title, description, testID = 'IndicatorStep' }) => {
  return (
    <div data-testid={testID} className="my-2 md:w-1/2">
      <div className="flex flex-row items-start">
      {!!error ? <CrossIcon color={$colors.error}/> : <CheckIcon color={$colors.primary} width={40}/>}
        <SText label={title} classNames='text-md text-gray-600 ml-2' />
      </div>
      <div className='ml-8'>
        {!!error && <TextError message={error.message} className='block text-sm'/>}
        </div>
    </div>
  );
};
